import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.125 9.75C6.125 9.19772 6.57272 8.75 7.125 8.75H16.875C17.4273 8.75 17.875 9.19772 17.875 9.75C17.875 10.3023 17.4273 10.75 16.875 10.75H7.125C6.57272 10.75 6.125 10.3023 6.125 9.75Z",
      fill: "#A466FC"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.125 12.75C6.125 12.1977 6.57272 11.75 7.125 11.75H16.875C17.4273 11.75 17.875 12.1977 17.875 12.75C17.875 13.3023 17.4273 13.75 16.875 13.75H7.125C6.57272 13.75 6.125 13.3023 6.125 12.75Z",
      fill: "#A466FC"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 5.5V17.882L5.55279 17.1056C5.83431 16.9648 6.16569 16.9648 6.44721 17.1056L9 18.382L11.5528 17.1056C11.8343 16.9648 12.1657 16.9648 12.4472 17.1056L15 18.382L17.5528 17.1056C17.8343 16.9648 18.1657 16.9648 18.4472 17.1056L20 17.882V5.5H4ZM2.51256 4.01256C2.84075 3.68438 3.28587 3.5 3.75 3.5H20.25C20.7141 3.5 21.1592 3.68437 21.4874 4.01256C21.8156 4.34075 22 4.78587 22 5.25V19.5C22 19.8466 21.8205 20.1684 21.5257 20.3507C21.2309 20.5329 20.8628 20.5494 20.5528 20.3944L18 19.118L15.4472 20.3944C15.1657 20.5352 14.8343 20.5352 14.5528 20.3944L12 19.118L9.44721 20.3944C9.16569 20.5352 8.83431 20.5352 8.55279 20.3944L6 19.118L3.44721 20.3944C3.13723 20.5494 2.76909 20.5329 2.47427 20.3507C2.17945 20.1684 2 19.8466 2 19.5V5.25C2 4.78587 2.18438 4.34075 2.51256 4.01256Z",
      fill: "#A466FC"
    }, null, -1)
  ])))
}
export default { render: render }